module.exports = __webpack_public_path__ + "img/centrifuge-B.759fbe3a.png";